const possibleRotations = [ 'rotate-1', '-rotate-1' ]
export const getRandomRotations = () => {
  // Generate the first two random rotations
  const firstRotation = possibleRotations[Math.floor(Math.random() * possibleRotations.length)]
  const secondRotation = possibleRotations[Math.floor(Math.random() * possibleRotations.length)]
  
  // If the first two are the same, make the third different
  const thirdRotation = (firstRotation === secondRotation)
    ? (firstRotation === 'rotate-1' ? '-rotate-1' : 'rotate-1')
    : possibleRotations[Math.floor(Math.random() * possibleRotations.length)]

  return [ firstRotation, secondRotation, thirdRotation ]
}